// extracted by mini-css-extract-plugin
export default {"category":"jFdAt","list":"lNtjx"};